import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

interface DayTypeInsertModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: (insertToCurrentDay: boolean) => void;
}

const DayTypeInsertModal: React.FC<DayTypeInsertModalProps> = ({
  show,
  onHide,
  onConfirm
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Insert Day Type</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Do you want to insert this day type to the current day or the next day?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => onConfirm(true)}>
          Insert to Current Day
        </Button>
        <Button variant="primary" onClick={() => onConfirm(false)}>
          Insert to Next Day
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DayTypeInsertModal;
